<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Relatório de Marcação de Consultas</h2>
                    </div>
                </div>

                <div class="panel-body">

                    <form [formGroup]="formularioDeMarcacaoDeConsultas" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                                <mat-label>Filial</mat-label>
                                <mat-select value="Filial" formControlName="filial" name="filial" id="filial" required>
                                    <mat-option *ngFor="let filial of listaFiliais" [value]="filial">
                                        {{filial.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="formularioDeMarcacaoDeConsultas.controls.filial.hasError('required')">
                                    O campo Filial é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-2 col-md-4 col-sm-4 col-12">
                                <mat-label>Data Marcação</mat-label>
                                <input matInput [matDatepicker]="dataInicialDP" formControlName="dataInicial"
                                    id="dataInicial" name="dataInicial">
                                <mat-datepicker-toggle matSuffix [for]="dataInicialDP"></mat-datepicker-toggle>
                                <mat-datepicker #dataInicialDP></mat-datepicker>

                                <mat-error
                                    *ngIf="formularioDeMarcacaoDeConsultas.controls.dataInicial.hasError('required')">
                                    O campo Data Marcação é obrigatório.
                                </mat-error>

                                <mat-error
                                    *ngIf="formularioDeMarcacaoDeConsultas.controls.dataInicial.hasError('invalidDate')">
                                    O campo Data Marcação está inválido.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-5 col-md-8 col-sm-8 col-12">
                                <mat-label>Consultas</mat-label>
                                <mat-select formControlName="procedimentos" name="procedimentos" id="procedimentos"
                                    multiple>
                                    <mat-select-trigger>
                                        {{(controlProcedimentos.value && controlProcedimentos.value[0]) ?
                                        controlProcedimentos.value[0].nome : ''}}
                                        <span *ngIf="controlProcedimentos.value?.length > 1"
                                            class="example-additional-selection">
                                            (+{{controlProcedimentos.value.length - 1}}
                                            {{controlProcedimentos.value?.length === 2 ? 'outro' :
                                            'outros'}})
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let procedimentoConsulta of listaDeProcedimentoConsulta"
                                        [value]="procedimentoConsulta">
                                        {{procedimentoConsulta.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeMarcacaoDeConsultas.controls.procedimentos.hasError('required')">
                                    Selecione pelo menos uma Consulta.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-5 col-md-12 col-sm-12 col-12">
                                <mat-label>Médicos</mat-label>
                                <mat-select formControlName="medicos" name="medicos" id="medicos" multiple>
                                    <mat-select-trigger>
                                        {{(controlMedicos.value && controlMedicos.value[0]) ?
                                        controlMedicos.value[0].nome : ''}}
                                        <span *ngIf="controlMedicos.value?.length > 1"
                                            class="example-additional-selection">
                                            (+{{controlMedicos.value.length - 1}}
                                            {{controlMedicos.value?.length === 2 ? 'outro' :
                                            'outros'}})
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let medico of listaDeMedicos" [value]="medico">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeMarcacaoDeConsultas.controls.medicos.hasError('required')">
                                    Selecione pelo menos um Médico.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-12 col-md-12 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeMarcacaoDeConsultas.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>